import { BaseNetworkActionValidator } from '../base.network.action.validator';
import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';

export class MoveToActionValidator extends BaseNetworkActionValidator {
  protected canRunForUnmanagedCompanies = true;
  protected requiresTasksEnabled = false;
  protected canRunOnMultipleCompanies = false;

  private unmovableTypes: Array<number> = [
    Constants.Companies.TYPE_COMPANIES_COLLECTION,
    Constants.Companies.TYPE_COMPANY_NETWORK,
    Constants.ProtectedEntities.EPS.CUSTOM_GROUPS,
    Constants.ProtectedEntities.EPS.TYPE_EXCLUDED_FOLDER,
    Constants.ProtectedEntities.EPS.ACTIVE_DIRECTORY,
    Constants.ProtectedEntities.EPS.TYPE_AD_COMPUTER_GROUP,
    Constants.ProtectedEntities.EPS.TYPE_AD_COMPUTER,
    Constants.ProtectedEntities.EPS.TYPE_AWS_AZ,
    Constants.ProtectedEntities.EPS.TYPE_AWS_ACCOUNT,
    Constants.ProtectedEntities.EPS.TYPE_AWS_INSTANCE,
    Constants.ProtectedEntities.EPS.TYPE_AWS_GROUP,
    Constants.ProtectedEntities.EPS.TYPE_AWS_REGION,
    Constants.ProtectedEntities.EPS.TERMINATED_INSTANCES_GROUP,
    Constants.ProtectedEntities.CONTAINERS.TYPE_COLLECTION,
    Constants.ProtectedEntities.CONTAINERS.TYPE_CUSTOM_GROUPS,
    Constants.ProtectedEntities.CONTAINERS.TYPE_CONTAINER,
    Constants.ProtectedEntities.EPS.VMWARE_COLLECTION,
    Constants.ProtectedEntities.EPS.VMWARE_CENTER,
    Constants.ProtectedEntities.EPS.VMWARE_DATACENTER,
    Constants.ProtectedEntities.EPS.VMWARE_FOLDER,
    Constants.ProtectedEntities.EPS.VMWARE_COMPUTE_RESOURCE,
    Constants.ProtectedEntities.EPS.VMWARE_CLUSTER_COMPUTE_RESOURCE,
    Constants.ProtectedEntities.EPS.VMWARE_RESOURCE_POOL,
    Constants.ProtectedEntities.EPS.VMWARE_VIRTUAL_APP,
    Constants.ProtectedEntities.EPS.VMWARE_HOST_SYSTEM,
    Constants.ProtectedEntities.EPS.VMWARE_VIRTUAL_MACHINE
  ];

  private movableTypes: Array<number> = [
    Constants.Companies.TYPE_COMPANY_FOLDER,
    Constants.Companies.TYPE_COMPANY,
    Constants.ProtectedEntities.EPS.TYPE_CUSTOM_GROUP,
    Constants.ProtectedEntities.CONTAINERS.TYPE_HOST,
    Constants.ProtectedEntities.CONTAINERS.TYPE_FOLDER,
  ];

  protected _canPerformAction(record: ProtectedEntity): boolean {
    if (record._id === Application.Main.user.company.id) {
      return false;
    }

    if (this.unmovableTypes.includes(record.type)) {
      return false;
    }

    if (this.movableTypes.includes(record.type)) {
      return true;
    }

    return true;
  }
}
